import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import React, { useEffect } from "react";
import { Toaster } from "sonner";
import { CartProvider } from "./context/CartContext";
import { AuthProvider } from "./context/AuthContext";
import { Header } from "./components/Header";
import { Footer } from "./components/Footer";
import { WhatsAppFloat } from "./components/WhatsAppFloat";
import { ChatWidget } from "./components/ChatWidget";
import { IntroVideo } from "./components/IntroVideo";
import Home from "./pages/Home";
import Catalog from "./pages/Catalog";
import Cart from "./pages/Cart";
import Checkout from "./pages/Checkout";
import PaymentSuccess from "./pages/PaymentSuccess";
import ThankYou from "./pages/ThankYou";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import CataPrivada from "./pages/CataPrivada";
import VentasMayor from "./pages/VentasMayor";
import MenuRestaurante from "./pages/MenuRestaurante";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  componentDidCatch(error, errorInfo) {
    console.error("ErrorBoundary caught:", error, errorInfo);
    if (window.posthog) {
      window.posthog.captureException(error);
    }
    var RELOAD_KEY = "cg_boot_reload_attempted";
    var alreadyTried = false;
    try { alreadyTried = sessionStorage.getItem(RELOAD_KEY) === "1"; } catch (e) {}
    if (!alreadyTried) {
      try { sessionStorage.setItem(RELOAD_KEY, "1"); } catch (e) {}
      window.location.reload();
    }
  }
  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: "3rem", textAlign: "center", color: "#F3F3F3", minHeight: "60vh", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
          <p style={{ fontSize: "1.2rem", marginBottom: "1rem" }}>Algo salió mal.</p>
          <button
            onClick={() => window.location.reload()}
            style={{ padding: "0.75rem 2rem", backgroundColor: "#D97736", color: "#000", border: "none", cursor: "pointer", fontWeight: 600, textTransform: "uppercase", letterSpacing: "0.1em" }}
          >
            Recargar página
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => window.scrollTo(0, 0), [pathname]);
  return null;
}

function AppShell() {
  const { pathname } = useLocation();
  const noChrome = pathname === "/admin";

  return (
    <div className="App">
      {!noChrome && <IntroVideo />}
      {!noChrome && <Header />}
      <main>
        <ErrorBoundary>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/catalogo" element={<Catalog />} />
            <Route path="/menu" element={<MenuRestaurante />} />
            <Route path="/cata-privada" element={<CataPrivada />} />
            <Route path="/ventas-mayor" element={<VentasMayor />} />
            <Route path="/carrito" element={<Cart />} />
            <Route path="/checkout" element={<Checkout />} />
            <Route path="/pago-exitoso" element={<PaymentSuccess />} />
            <Route path="/gracias" element={<ThankYou />} />
            <Route path="/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminDashboard />} />
          </Routes>
        </ErrorBoundary>
      </main>
      {!noChrome && <Footer />}
      <WhatsAppFloat />
      {!noChrome && <ChatWidget />}
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <CartProvider>
          <ScrollToTop />
          <Toaster position="top-right" theme="dark" richColors />
          <AppShell />
        </CartProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
